<dx-popup
  (onHidden)="this.onHidden()"
  [title]="this.title"
  [(visible)]="this.isVisible"
  [resizeEnabled]="true"
  [dragEnabled]="true"
  [width]="this.width"
  [height]="this.height"
  maxHeight="90vh"
  [wrapperAttr]="this.popupWrapperAttr"
>
  <div *dxTemplate="let data of 'content'" class="dialog-root">

    <!-- One order's markup, shared by the verification panel and the read-only preview panel
         (CR-20260827-001) so the two can never drift apart in format. -->
    <ng-template #verificationTpl let-model="model" let-isLast="isLast" let-isPreview="isPreview" let-ix="ix">
      <div class="verification">

        <!-- The naked-leg order ALONE gets the exclamation mark (owner 2026-09-03: painting every
             header was too aggressive; orange, never red). The explicit warning sits once, under
             the pager, at the top of the preview pane. -->
        <div class="zone-title" *ngIf="isPreview">
          <i class="fas fa-exclamation-circle naked-icon" *ngIf="model.naked"
             title="This order contains a naked leg. Execute it before the other orders."></i>
          {{model.title}}
        </div>

        <div class="message">
          <div class="default-qty">
            <span class="label">Default Qty: &nbsp;</span>
            <span class="qty">{{model.defaultQty}}</span>
          </div>

          <div class="ledger-price">
            Ledger Price:
            <span [class.debit]="model.ledgerPrice() < 0" [class.credit]="model.ledgerPrice() > 0">
          {{model.ledgerPrice() | currency : 'USD':'symbol':'1.2-2'}}
        </span>
            <span class="pricing-steps-icon" *ngIf="this.pricingStepsAvailable"
                  (click)="this.showPricingSteps(model, ix)" title="Pricing Steps">
              <i class="fas fa-chart-line fa-lg"></i>
            </span>
          </div>
          <div class="hedge-name" *ngIf="model.isNewHedge && !isPreview">
            <dx-text-box
                [(value)]="model.hedgeName"
                [placeholder]="model.hedgePlaceholder"
                (onValueChanged)="this.onHedgeNameChanged()"
                class="hedge-name-input"
            ></dx-text-box>
          </div>
        </div>

        <div class="order-legs">

          <div class="table">

            <div class="leg header">
              <div class="cell ticker header">Ticker</div>
              <div class="cell side header">Side</div>
              <div class="cell qty header">Total Qty</div>
              <div class="cell qty header">Effect. Qty</div>
              <div class="cell price header">Price</div>
            </div>

            <div class="legs">
              <div class="leg" *ngFor="let leg of model.orderLegs">
                <div class="cell ticker">
                  {{leg.tickerDisplayName}}
                </div>
                <div class="cell side" [class.buy]="leg.side === 1" [class.sell]="leg.side === -1">
                  {{leg.side === 1 ? 'Buy' : 'Sell' }}
                </div>
                <div class="cell qty">{{leg.netPosition}}</div>
                <div class="cell qty">{{leg.netPosition * leg.side / model.hcf}}</div>
                <div class="cell price" [class.debit]="leg.side === 1" [class.credit]="leg.side === -1">
                  {{((leg.price * leg.side * -1 ) | currency:'USD':'symbol':'1.2-2')}}
                </div>
              </div>
            </div>

            <div class="leg footer">
              <div class="cell ticker">&nbsp;</div>
              <div class="cell side">&nbsp;</div>
              <div class="cell qty total">&nbsp;</div>
              <div class="cell qty total">x{{model.hcf}}</div>
              <div class="cell price total" [class.debit]="model.transPrice < 0" [class.credit]="model.transPrice > 0">
                {{(model.transPrice | currency:'USD':'symbol':'1.2-2')}}
              </div>
            </div>

          </div>

          <div class="summary">

            <div class="column text">
              <div class="order-placement">
                Order Placement Price
              </div>
              <div class="trans-value">
                Transaction's Market Value
              </div>
            </div>

            <div class="column value">
              <div class="order-placement" [class.debit]="model.transMarketValue < 0" [class.credit]="model.transMarketValue > 0">
                {{(model.transPrice | currency:'USD':'symbol':'1.2-2')}}
              </div>
              <div class="trans-value" [class.debit]="model.transMarketValue < 0" [class.credit]="model.transMarketValue > 0">
                {{(model.transMarketValue | currency:'USD':'symbol':'1.2-2')}}
              </div>
            </div>

          </div>

        </div>

        <hr class="separator" *ngIf="!isLast">

      </div>
    </ng-template>

    <div class="split" #dialogRoot>

      <div class="pane original">

        <div class="orders">

          <dx-scroll-view>
            <ng-container *ngFor="let model of this.verifications; let isLast = last; let ix = index">
              <ng-container
                  *ngTemplateOutlet="verificationTpl; context: {model: model, isLast: isLast, isPreview: false, ix: ix}">
              </ng-container>
            </ng-container>
          </dx-scroll-view>

        </div>

        <hr class="separator">

        <div class="buttons">
          <div class="btn ok" *ngIf="this.showCopyOrdersButton">
            <dx-button (onClick)="this.onOkClicked()"
                       [text]="this.confirmButtonText"
                       [disabled]="!this.canConfirm"
                       width="100%"
            ></dx-button>
          </div>
          <div class="btn cancel">
            <dx-button (onClick)="this.onCancelClicked()"
                       text="Cancel"
                       width="100%"
            ></dx-button>
          </div>
          <!-- CR-20260827-001: shows up only when the backend arrangement differs from the
               package (rule A). Toggles the read-only preview panel on the right.
               CR-20260830-002: RED when the answer is degraded (naked residue) - the run is
               presented as failed. -->
          <div class="btn optimize" [class.degraded]="this.previewDegraded" *ngIf="this.optimizeAvailable">
            <dx-button (onClick)="this.toggleOptimizePreview()"
                       text="Optimize Grouping"
                       width="100%"
            ></dx-button>
          </div>
        </div>

      </div>

      <!-- THE PREVIEW IS A PURE PREVIEW: no buttons, ever (owner). Orange border because it
           represents the improvement of the orders for execution; RED when the shown solution
           is degraded (naked residue) - red replaces orange (CR-20260830-002). The pager slides
           between the backend's ranked solutions; one solution renders no pager. -->
      <div class="pane preview" [class.degraded]="this.previewDegraded" *ngIf="this.previewVisible">
        <ets-ooa-solution-pager [count]="this.previewPageCount"
                                [index]="this.previewPageIx"
                                (indexChange)="this.onPreviewPageChanged($event)"
        ></ets-ooa-solution-pager>
        <!-- First thing the user reads when the optimized grouping opens: which order carries the
             naked leg and that it must be executed before the others (owner 2026-09-03). -->
        <div class="naked-warning" *ngIf="this.previewNakedTitles">
          <i class="fas fa-exclamation-circle"></i>
          {{this.previewNakedTitles}} contains a naked leg &mdash; execute this order before the others.
        </div>
        <div class="orders">
          <dx-scroll-view>
            <ng-container *ngFor="let model of this.previewVerifications; let isLast = last; let ix = index">
              <ng-container
                  *ngTemplateOutlet="verificationTpl; context: {model: model, isLast: isLast, isPreview: true, ix: ix}">
              </ng-container>
            </ng-container>
          </dx-scroll-view>
        </div>
      </div>

    </div>

    <!-- Fixed width so a message swap never resizes the panel (owner bug 2026-09-01); the swap
         itself runs under @DetectMethodChanges (owner-directed round 3). -->
    <dx-load-panel [visible]="this.isLoading"
                   [shading]="true"
                   [message]="this.loadingMessage"
                   [width]="360"
                   height="110"
                   [position]="{my: 'center', at: 'center', of: dialogRoot}"
    ></dx-load-panel>

  </div>
</dx-popup>
